<div class="buttons-bottom" [ngClass]="{ 'no-margin': removeMargin() }">
	<!-- use a span tag with the note id to show additional info in the buttons bottom section -->
	<div class="spacer"></div>
	<ng-content></ng-content>
</div>
